import {MarkedExtension, Tokens} from 'marked';


export function markedHighlight2(options: any): MarkedExtension {
    if (typeof options === 'function') {
        options = {
            highlight: options,
        };
    }

    if (!options || typeof options.highlight !== 'function') {
        throw new Error('Must provide highlight function');
    }

    if (typeof options.langPrefix !== 'string') {
        options.langPrefix = 'language-';
    }

    if (typeof options.emptyLangClass !== 'string') {
        options.emptyLangClass = '';
    }

    return {
        async: !!options.async,
        walkTokens(token: any) {
            if (token.type !== 'code') {
                return undefined;
            }

            const lang = getLang(token.lang);

            if (options.async) {
                return Promise.resolve(options.highlight(token.text, lang, token.lang || '')).then(updateToken(token));
            }

            const code = options.highlight(token.text, lang, token.lang || '');
            if (code instanceof Promise) {
                throw new Error('markedHighlight is not set to async but the highlight function is async. Set the async option to true on markedHighlight to await the async highlight function.');
            }
            updateToken(token)(code);
            return undefined;
        },
        // useNewRenderer: true,
        renderer: {
            code(obj: Tokens.Code): string {
                // istanbul ignore next
                const escaped = obj.escaped;
                const infoString = obj.lang;
                let code = obj.text;
                const lang = getLang(infoString);
                const classValue = lang ? options.langPrefix + escape(lang) : options.emptyLangClass;
                const classAttr = classValue
                    ? ` class="${classValue}"`
                    : '';
                code = code.replace(/\n$/, '');
                return `<pre><code${classAttr}>${escaped ? code : escape(code, true)}\n</code></pre>`;
            },
        },
    };
}

function getLang(lang: any) {
    return (lang || '').match(/\S*/)[0];
}

function updateToken(token: any) {
    return (code: any) => {
        if (typeof code === 'string' && code !== token.text) {
            token.escaped = true;
            token.text = code;
        }
    };
}

// copied from marked helpers
const escapeTest = /[&<>"']/;
const escapeReplace = new RegExp(escapeTest.source, 'g');
const escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
const escapeReplaceNoEncode = new RegExp(escapeTestNoEncode.source, 'g');
const escapeReplacements: any = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
};
const getEscapeReplacement = (ch: string) => escapeReplacements[ch];
function escape(html: any, encode: boolean = false) {
    if (encode) {
        if (escapeTest.test(html)) {
            return html.replace(escapeReplace, getEscapeReplacement);
        }
    } else {
        if (escapeTestNoEncode.test(html)) {
            return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
        }
    }

    return html;
}
